import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Card = ({
  size,
  type,
  theme,
  className,
  dataTestId = "card-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M10.5094 9.32234C10.1412 9.32234 9.84273 9.62081 9.84273 9.989C9.84273 10.3572 10.1412 10.6557 10.5094 10.6557H12.2527C12.6209 10.6557 12.9193 10.3572 12.9193 9.989C12.9193 9.62081 12.6209 9.32234 12.2527 9.32234H10.5094Z" />
    <path
      d="M0.0497589 4.25046C0.0497589 2.99861 1.06458 1.9838 2.31643 1.9838H13.7277C14.9796 1.9838 15.9944 2.99862 15.9944 4.25046V11.7496C15.9944 13.0014 14.9796 14.0162 13.7277 14.0162H2.31642C1.06458 14.0162 0.0497589 13.0014 0.0497589 11.7496V4.25046ZM2.31643 3.31713C1.80096 3.31713 1.38309 3.735 1.38309 4.25046V5.58796H14.6611V4.25046C14.6611 3.735 14.2432 3.31713 13.7277 3.31713H2.31643ZM1.38309 11.7496V7.45463H14.6611V11.7496C14.6611 12.265 14.2432 12.6829 13.7277 12.6829H2.31642C1.80096 12.6829 1.38309 12.265 1.38309 11.7496Z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </SVGIcon>
);
